import calender from '../../../../images/industries/calender.svg';

export const widgetTitle = 'Related Training Courses';
export const widgetContent = 'Accidental Release Modeling Workshop';
export const widgetDate = 'June 23, 2020';
export const widgetSubContent = 'Dallas, TX';
export const widgetLink = 'All Software Training Courses ›';
export const widgetImage = calender;
